<template>
  <div class="flex items-center space-x-2 px-2 py-1 transition hover:bg-ctp-base/50">
    <slot />
  </div>
</template>
